<!-- 年度各月资金使用兑付情况 -->
<template>
  <div id="rightFourthchart" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
let chartVm = null;
function numberSeparatorCompute(number) {
    let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
    if (!number) {
      return 0;
    }else {
      return number.toFixed(0).replace(regex, ',');
    }
};
function numberFloatSeparatorCompute(number) {
  let num = number;
  if(!number) {
    num = 0;
  }
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
export default {
  mixins: [resize],
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      chart: null,
      monthData: [],
      data1: [],
      data2: [],
      options: {
        legend: {
          top: '4px',
          icon: 'rect',
          itemWidth: 12,         // 图标宽度
          itemHeight: 4,         // 图标高度
          right: '16px',
          selected: {
            hide: false
          },
          data: [
            {
              name: '使用',
              color: 'rgba(38, 255, 114, 1)'
            },
            {
              name: '兑付',
              color: 'rgba(255, 174, 13, 1)'
            }
          ],
          textStyle: {
            color: '#fff',
            fontFamily: 'Microsoft YaHei',
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 31, 11, 0.4)',
          formatter: function(params) {
            let html = `<div>${params[0].name}</div>`;
            params.forEach(param => {
              let marker = `<span style="display:inline-block;margin-bottom: 3px;margin-right:5px;width:12px;height:4px;background-color:${param.color}"></span>`
              html += `${marker} ${param.seriesName}： ${numberFloatSeparatorCompute(param.value || 0)} 万元</br>`; // 示例：添加百分比符号
            });
            return html;
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: new echarts.graphic.LinearGradient(0,0,0,1, 
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: 'rgba(0, 255, 132, 0.1)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(0, 255, 132, 1)',
                  },
                ]
              )
            }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(161, 207, 219, 0.15)',
              type: 'solid'
            }
          },
          axisLabel: {
            show: true,
            color: '#BABBBD',
            fontSize: 12,
            fontFamily: 'Microsoft YaHei',
            margin: 16
          }
        },
        yAxis: {
          name: '(万元)',
          nameTextStyle: {
            color: '#BABBBD',
            fontSize: 12,
            align: 'right',
          },
          type: 'value',
          interval: 20,
          min: 0,
          max: 100,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'rgba(161, 207, 219, 0.15)',
              type: 'solid'
            }
          },
          axisLabel: {
            color: '#BABBBD',
            formatter: '{value}',
            fontSize: 12,
            fontFamily: 'MicrosoftYaHei'
          }
        },
        grid: {
          top: '34px',
          left: '50px',
          right: '21px',
          bottom: '18%'
        }
      }
    };
  },
  watch: {
    chartData() {
      this.monthData = this.chartData.map(item => {
        return item.month + '月';
      })
      this.data1 = this.chartData.map(item => {
        return item?.centralScrapUsedFund || 0;
      })
      this.data2 = this.chartData.map(item => {
        return item?.centralScrapSettlementFund || 0;
      })
      this.initChart()
    }
  },
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 300);
    });
  },
  mounted() {
    this.chartData.map(item => {
      this.monthData = this.chartData.map(item => {
        return item.month + '月';
      })
      this.data1 = this.chartData.map(item => {
        return item?.centralScrapUsedFund || 0;
      })
      this.data2 = this.chartData.map(item => {
        return item?.centralScrapSettlementFund || 0;
      })
    })
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      let series = [];
      let that = this;
      series.push({
        name: '使用',
        data: this.data1,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 1,
        itemStyle: {
          color: 'rgba(38, 255, 114, 1)',
          emphasis: {           // 悬停状态配置
            color: '#FFFFFF',   // 悬停填充色
            borderColor: 'rgba(98, 255, 153, 0.2)',
            borderWidth: 6,
            shadowBlur: 6,     // 阴影模糊度
            shadowColor: 'rgba(98, 255, 153, 1)',
            symbolSize: 10      // 悬停时图标放大
          }
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(32, 214, 96, 0.05)' },
            { offset: 1, color: 'rgba(32, 214, 96, 0.2)' }
          ])
        }
      });
      series.push({
        name: '兑付',
        data: this.data2,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 1,
        itemStyle: {
          color: 'rgba(255, 174, 13, 1)',
          emphasis: {           // 悬停状态配置
            color: '#FFFFFF',   // 悬停填充色
            borderColor: 'rgba(255, 211, 122, 0.2)',
            borderWidth: 6,
            shadowBlur: 10,     // 阴影模糊度
            shadowColor: 'rgba(255, 211, 122, 1)',
            symbolSize: 10      // 悬停时图标放大
          }
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(255, 174, 13, 0.05)' },
            { offset: 1, color: 'rgba(255, 174, 13, 0.2)' }
          ])
        },
        color: '#12f4d4'
      });
      this.options.xAxis.data = this.monthData;
      this.options.series = series;
      this.chart.setOption(this.options);
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById('rightFourthchart'));
      }
      this.setChartData();
    },
  },
};
</script>
